import React, { useState, useEffect } from "react";
import { Card, Input, Button, Typography, Space, message, Modal, Spin } from "antd";
import axios from "axios";

const { TextArea } = Input;
const { Title } = Typography;

const EndUserLicenseManager = () => {
  const [licenseText, setLicenseText] = useState("");
  const [storedLicense, setStoredLicense] = useState("");
  const [licenseId, setLicenseId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    axios
      .get("/privacyPolicy")
      .then((res) => {
        const license = res.data.find(
          (item) => item.type === "end_user_agreement"
        );
        if (license && license.policy) {
          setStoredLicense(license.policy);
          setLicenseId(license.id);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load license", err);
        setIsLoading(false);
        message.error("Failed to fetch End User License Agreement.");
      });
  }, []);

  const handleUpdate = () => {
    if (!licenseId || !licenseText.trim()) return;
    setIsUpdating(true);

    axios
      .put(`/privacyPolicy/${licenseId}`, {
        privacy_policy: licenseText,
      })
      .then((res) => {
        if (res.status === 200) {
          setStoredLicense(licenseText);
          setIsEditing(false);
          setLicenseText("");
          message.success("End User License Agreement updated successfully.");
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Failed to update the agreement.");
      })
      .finally(() => {
        setIsUpdating(false);
      });
  };

  const handleEditClick = () => {
    setLicenseText(storedLicense);
    setIsEditing(true);
  };

  if (isLoading) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ maxWidth: "800px", margin: "40px auto" }}>
      <Title level={3}>End User License Agreement</Title>

      {!storedLicense || isEditing ? (
        <Card bordered style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <TextArea
              rows={10}
              value={licenseText}
              onChange={(e) => setLicenseText(e.target.value)}
              placeholder="Write your End User License Agreement..."
              disabled={isUpdating}
            />
            <Space>
              <Button
                type="primary"
                onClick={handleUpdate}
                disabled={!licenseText.trim() || isUpdating}
                loading={isUpdating}
              >
                Update Agreement
              </Button>
              <Button
                onClick={() => {
                  setIsEditing(false);
                  setLicenseText("");
                }}
                disabled={isUpdating}
              >
                Cancel
              </Button>
            </Space>
          </Space>
        </Card>
      ) : (
        <Card
          bordered
          style={{
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            background: "#fafafa",
          }}
        >
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Title level={4}>Stored License Agreement</Title>
            <pre
              style={{
                whiteSpace: "pre-wrap",
                background: "white",
                padding: "16px",
                border: "1px solid #eee",
                borderRadius: "6px",
                fontSize: "15px",
              }}
            >
              {storedLicense}
            </pre>
            <Space>
              <Button onClick={handleEditClick}>Edit</Button>
            </Space>
          </Space>
        </Card>
      )}
    </div>
  );
};

export default EndUserLicenseManager;
